import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import LoadingSpinner from 'scy/LoadingSpinner';
import Promo from '../promo';
import { showPromo } from '../promo/actions';
import { firstPromoToApply } from 'shared/models/promo';
import { PrimaryButton } from 'scy/buttons';
import { block } from 'scy/display.mod.scss';
import { plainList } from 'scy/utils.mod.scss';
import { flex, centerItems, spaceBetween } from 'scy/flex.mod.scss';
import { SecondaryH6 } from 'scy/text';
import { highlight, sansSerifMedium } from 'scy/text/styles.mod.scss';
import margin from 'scy/margin.mod.scss';
import padding from 'scy/padding.mod.scss';
import border from 'scy/border.mod.scss';

const renderPromoValue = code => {
  if (!code) return '';
  switch (code.value_type) {
    case '%':
      return `${100 * code.value}% Off`;
    case 'hour':
      return code.value === 1 ? `${code.value} Hour` : `${code.value} Hours`;
    default:
      return `$${code.value}`;
  }
};

function PromoCodeRow({ title, subtitle, value, isSelected }) {
  return (
    <SecondaryH6
      uppercase
      tag="div"
      className={classnames(
        flex,
        centerItems,
        spaceBetween,
        padding.top_sm,
        padding.bottom_sm,
        border.bottomMedium,
        {
          [highlight]: isSelected,
          [sansSerifMedium]: isSelected
        }
      )}
    >
      <div>
        <div>{title}</div>
        {!!subtitle && <div>{subtitle}</div>}
      </div>
      <div>{value}</div>
    </SecondaryH6>
  );
}

class Promos extends React.Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.props.showPromo(true);
  }

  closeModal() {
    this.props.showPromo(false);
  }

  render() {
    const credit = this.props.credit;
    const codes = this.props.codes || [];
    const selectedPromo =
      credit && !!credit.balance ? credit : firstPromoToApply(codes);

    return (
      <>
        {this.state.loading && <LoadingSpinner black backdrop />}

        {(!!credit || !!codes.length) && (
          <ul className={`${plainList} ${margin.bottom_md}`}>
            {!!credit && (
              <PromoCodeRow
                title="Available Gift Credit"
                value={`$${credit.balance}`}
                isSelected={
                  selectedPromo && selectedPromo.value_type === 'credit'
                }
              />
            )}

            {codes.map(promo => (
              <PromoCodeRow
                key={promo.code}
                title={promo.label}
                subtitle={promo.desc}
                value={renderPromoValue(promo)}
                isSelected={selectedPromo && selectedPromo.code === promo.code}
              />
            ))}
          </ul>
        )}

        <PrimaryButton
          type="button"
          className={classnames(block, margin.sides_auto, margin.tablet_left_0)}
          onClick={this.openModal}
        >
          Add Promo or Gift Card
        </PrimaryButton>

        <Promo />
      </>
    );
  }
}

function mapStateToProps(state) {
  return { ...state.promo };
}

export default connect(
  mapStateToProps,
  { showPromo }
)(Promos);
